import React from "react";
import frame from "../../Assets/Images/WorkImages/frame.webp";
import Mask from "../../Assets/Images/WorkImages/Mask.webp";
import Mask1 from "../../Assets/Images/WorkImages/Mask1.webp";
import Mask2 from "../../Assets/Images/WorkImages/Mask2.webp";

const Work = () => {
  const works = [
    {
      img: Mask1,
      heading: "1. Select your Beauty Service",
      details:
        "Browse our wide range of salon services—from makeup and hair care to spa treatments—and choose what suits your style.",
    },
    {
      img: Mask,
      heading: "2. Book Instantly",
      details:
        "Pick your preferred date and time, book instantly, and complete your payment with our safe and hassle-free processes.",
    },
    {
      img: Mask2,
      heading: "3. Relax & Get Pampered",
      details:
        "Sit back and enjoy professional salon services delivered right to your doorstep by our trained beauty experts.",
    },
  ];

  return (
    <section
      style={{ backgroundImage: `url(${frame})` }}
      className="px-4 pt-4 pb-8 sm:px-8 md:px-10 lg:px-12 
                 rounded-xl mx-4 md:mx-8 lg:mx-12
                 bg-cover bg-center bg-no-repeat"
    >
      {/* Heading */}
      <div
        data-aos="fade-up"
        className="py-2 mb-4 text-center flex flex-col items-center gap-2"
      >
        <h1 className="font-philosopher text-2xl sm:text-3xl lg:text-4xl text-white">
          How Sakhi <span className="text-[#EDB5A4]">Works</span>
        </h1>
        <p className="text-sm sm:text-base font-robotoflex max-w-xl text-white/80">
          Each listing is designed to be clear and concise, providing customers
        </p>
      </div>

      {/* Cards */}
      <div
        className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-3 gap-6 place-items-center tracking-wider"
      >
        {works.map((item, index) => (
          <div
            key={index}
            data-aos="fade-up"
            data-aos-delay={index * 180}
            data-aos-anchor-placement="top-bottom"
            className="flex flex-col items-center text-center space-y-4
                       bg-white/10 backdrop-blur-md border border-white/20 
                       rounded-2xl p-6 shadow-lg hover:scale-105 transform transition-all duration-300"
          >
            <img
              src={item.img}
              alt={item.heading}
              className="w-12 h-12 md:w-14 md:h-14"
            />

            <div className="text-white max-w-xs md:max-w-sm flex flex-col gap-2">
              <h2 className="font-philosopher text-xl md:text-2xl font-bold">
                {item.heading}
              </h2>
              <p className="text-xs md:text-sm">
                {item.details}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Work;





// import React, { useEffect } from "react";
// import frame from "../../Assets/Images/WorkImages/frame.webp";
// import Mask from "../../Assets/Images/WorkImages/Mask.webp";
// import Mask1 from "../../Assets/Images/WorkImages/Mask1.webp";
// import Mask2 from "../../Assets/Images/WorkImages/Mask2.webp";

// const Work = () => {
//   const works = [
//     {
//       img: Mask1,
//       heading: "1. Select your Beauty Service",
//       details:
//         "Browse our wide range of salon services—from makeup and hair care to spa treatments—and choose what suits your style.",
//     },
//     {
//       img: Mask,
//       heading: "2. Book Instantly",
//       details:
//         "Pick your preferred date and time, book instantly, and complete your payment with our safe and hassle-free processes.",
//     },
//     {
//       img: Mask2,
//       heading: "3. Relax & Get Pampered",
//       details:
//         "Sit back and enjoy professional salon services delivered right to your doorstep by our trained beauty experts.",
//     },
//   ];

//   return (
//     <section
//       style={{ backgroundImage: `url(${frame})` }}
//       className="px-4 py-8 sm:px-8 md:px-10 lg:px-12 
//                  rounded-lg mx-4 md:mx-8 lg:mx-12
//                  bg-cover bg-center bg-no-repeat md:py-12 lg:py-16"
//     >
//       {/* Heading */}
//       <div
//         data-aos="fade-up"
//         className="py-2 mb-6 md:py-6 text-white text-center flex flex-col items-center gap-2"
//       >
//         <h1 className="font-philosopher text-2xl sm:text-3xl lg:text-4xl">
//           How Sakhi <span className="text-[#EDB5A4]">Works</span>
//         </h1>
//         <p className="text-sm sm:text-base font-robotoflex max-w-xl">
//           Each listing is designed to be clear and concise, providing customers
//         </p>
//       </div>

//       {/* Cards */}
//       <div
//         className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-3 
//                       gap-4 md:gap-6 lg:gap-4 place-items-center"
//       >
//         {works.map((item, index) => (
//           <div
//             key={index}
//             data-aos="fade-up"
//             data-aos-delay={index * 180}
//             data-aos-anchor-placement="top-bottom"
//             className="flex flex-col items-center text-center space-y-4"
//           >
//             <img
//               src={item.img}
//               alt={item.heading}
//               className="w-10 h-10 md:w-12 md:h-12"
//             />

//             <div className="text-white max-w-xs md:max-w-sm flex flex-col gap-2">
//               <h2 className="font-philosopher text-lg md:text-xl font-bold whitespace-nowrap">
//                 {item.heading}
//               </h2>
//               <p className="font-robotoflex text-sm md:text-base xl:w-64">
//                 {item.details}
//               </p>
//             </div>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default Work;
